import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { Dialog } from "primereact/dialog"

import { Button } from "../../../helpers"
import CopyToClipboard from "../../../common/CopyToClipboard"

import BuyerQuotesListWithNoPOModal from "./BuyerQuotesListWithNoPOModal"
import NewBuyerQuotationModalData from "./NewBuyerQuotationModalData"

import { getBuyerQuoteWithNoPO } from "../../../services/api/buyerQuote"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"
import { getCompanyShortName, getDateString, getFullName, getReqShortDetails } from "../../../utils"
import Tooltip from "../../../helpers/Tooltip"
import PMUserName from "../../../common/PMUserName"


const QuotationModal = (props) => {
    const navigate = useNavigate()
    const { selectedReq, visibleQuotes, setVisibleQuotes, setIsPageLoading, buyerReqItems, approvalInstances, materialDetails, sellerReqItems } = props
    
    const [buyerQuotes, setBuyerQuotes] = useState([])
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [buyerQuotesWithNoPOList, setBuyerQuotesWithNoPOList] = useState([])
    const [isBuyerQuoteListModalVisible, setIsBuyerQuoteModalVisible] = useState(false)

    const dispatch = useDispatch()
    const buyerQuoteData = useSelector(state => state.requirements.buyerQuoteData)
    const userId = useSelector(state => state.userDetails)?.userId
    const orderTypes = useSelector(state => state.common.orderTypes)

    useEffect(() => {
        getBuyerQuotes()
    }, [buyerQuoteData, selectedReq])

    const getBuyerQuotes = async () => {
        let relatedBuyerQuotes = props.buyerQuotes?.filter(eachBuyerQuote => eachBuyerQuote?.buyerReqId === selectedReq?.buyerReqId)
        const relatedBuyerQuoteItems = props.buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqId === selectedReq?.buyerReqId)

        relatedBuyerQuotes = _.orderBy(relatedBuyerQuotes, ['createdAt'], ['desc'])

        setBuyerQuotes(relatedBuyerQuotes)
        setBuyerQuoteItems(relatedBuyerQuoteItems)
    }

    const handleNavigationToAuditProduct = async () => {
        setIsPageLoading(true)

        const buyerQuotes = await getBuyerQuoteWithNoPO(userId, selectedReq.companyId)
        if(!buyerQuotes?.failure){
            if(buyerQuotes?.data && buyerQuotes?.data?.length > 0){
                setIsBuyerQuoteModalVisible(true)
                const buyerQuoteWithNoPO = buyerQuotes?.data
                setBuyerQuotesWithNoPOList(buyerQuoteWithNoPO)
            }
            else{
                navigate(`/audit-product/${selectedReq?.buyerReqId}`)
            }
        }else{
            dispatch(raiseToast({ severity: 'error', summary: "Buyer Quote", detail: buyerQuotes?.data?.error, life: 3000 }))
        }

        setIsPageLoading(false)
    }

    let buyerName = getFullName(selectedReq["buyer.firstName"], selectedReq["buyer.lastName"])

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <p>BUYER QUOTATIONS</p>
                <div className="col-12 md:col-6 lg:col-10 m-0 p-0 pr-3 flex flex-row justify-content-end align-items-center">
                    <div>
                        <Button label="Add Quote" className="small-btn" onClick={handleNavigationToAuditProduct} />
                    </div>
                </div>
            </div>
        )
    }

    const renderRequirementDetails = (buyerReq) => {
        const { shortDenotation, fullDenotation } = getReqShortDetails(buyerReq, orderTypes)
        const kamName = getFullName(buyerReq["kam.firstName"], buyerReq["kam.lastName"])
        const companyDisplayName = getCompanyShortName(buyerReq["company.companyName"])
        const reqCreatedAt = getDateString(buyerReq.createdAt)
        // “Req: 121212 (copy sign) - V-RC-R - by abc def (gchat link) (Kolkata) on 12.12.2020 for <B> shortened buyer name </B> - Branch Name - Buyer Name”
        return (
            <p className="m-0">
                <span style={{fontWeight:"bold"}}>Req No: </span><span className="ml-1">{buyerReq["docNo"]} <CopyToClipboard text={buyerReq["docNo"]} /></span>
                <span className={`requirement-short-details`}> {shortDenotation}</span>
                <span className=""> by <PMUserName userName={kamName} userId={buyerReq.createdBy} /> ({buyerReq["pmCompanyBranch.branchName"]})</span> 
                <span className=""> on {reqCreatedAt}</span>
                <span className=""> for </span> <span style={{fontWeight:"bold"}}>{companyDisplayName} </span> <span className="ml-1"> - {buyerReq["buyerCompanyBranch.branchName"]} - {buyerName}</span>  

                <Tooltip target={`.requirement-short-details`} position='bottom'>
                    <span>{fullDenotation}</span>
                </Tooltip>
            </p>
        )
    }

    const handleOnHideDialog = () => {
        setBuyerQuoteItems([])
        setBuyerQuotes([])
        setVisibleQuotes(false)
    }

    return (
        <>
            <Dialog header={renderHeader} className="quotation-dialog" visible={visibleQuotes} style={{ width: '90vw', height: '85vh'}} onHide={() => handleOnHideDialog()}>
                <div className="quotation-modal">
                    { 
                        selectedReq ? renderRequirementDetails(selectedReq) : null 
                    }
                    {
                        <>
                            {
                                buyerQuotes?.length === 0 ? (
                                    <div className="flex justify-content-center mt-2">
                                        <p className="font-bold">Buyer quotes has not found for the selected buyer req.</p>
                                    </div>
                                ) : (
                                    buyerQuotes?.map(eachBuyerQuote => {
                                        const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerQuoteId === eachBuyerQuote?.buyerQuoteId)
                                        const relatedApprovalInstances = approvalInstances.filter(eachApprovaInstance => eachApprovaInstance.docNo === eachBuyerQuote.docNo)

                                        const buyerReqItemIds = [] 
                                        let uniqueBuyerQuoteItems = []
                                        relatedBuyerQuoteItems.forEach(eachQuoteItem => {
                                            if(!buyerReqItemIds.includes(eachQuoteItem.buyerReqItemId)){
                                                uniqueBuyerQuoteItems = [...uniqueBuyerQuoteItems, eachQuoteItem]
                                                buyerReqItemIds.push(eachQuoteItem.buyerReqItemId)
                                            }
                                        })
                                        let relatedBuyerReqItems = buyerReqItems.filter(eachBuyerReqItem => buyerReqItemIds.includes(eachBuyerReqItem.buyerReqItemId))
                                        let relatedMaterialDetails = materialDetails.filter(eachMaterial => buyerReqItemIds.includes(eachMaterial.buyerReqItemId))

                                        return (
                                            <NewBuyerQuotationModalData 
                                                key={`buyerQuote-${eachBuyerQuote.buyerQuoteId}`}
                                                buyerQuote={eachBuyerQuote}
                                                buyerQuoteItems={relatedBuyerQuoteItems}
                                                approvalInstances={relatedApprovalInstances}
                                                sellerReqItems={sellerReqItems}
                                                buyerQuoteId={eachBuyerQuote.buyerQuoteId}
                                                selectedReq={selectedReq} 
                                                materialDetails={relatedMaterialDetails}
                                                buyerReqItems={relatedBuyerReqItems}
                                            />
                                        )
                                    })
                                )
                            }
                        </>   
                    }
                </div>
            </Dialog>

            <Dialog header="QUOTES LIST WITH NO PO" visible={isBuyerQuoteListModalVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsBuyerQuoteModalVisible(false)}}>
                <div className="vendor-payment-summary-tab" style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <BuyerQuotesListWithNoPOModal buyerQuotesWithNoPOList={buyerQuotesWithNoPOList}  setIsBuyerQuoteModalVisible={setIsBuyerQuoteModalVisible}/>
                </div>
            </Dialog>
        </>
    )
}

export default QuotationModal